import TableComponents from './Table.vue';

const tables = {
    install:function(Vue) {
        Vue.component('tables', TableComponents)
    }
}

export default tables;